import type { Creature } from '@/domain/creature/types';
import { runCareTick } from '@/domain/care/orchestrator';
import { CATCHUP_MAX_MS } from '@/domain/care/constants';
import { logger } from '@/infra/logger/Logger';

/** Aplica tempo offline acumulado. Cap em CATCHUP_MAX_MS. */
export function catchUp(creature: Creature, savedAtMs: number, nowMs: number, lightOn: boolean): Creature {
  const dt = Math.max(0, Math.min(nowMs - savedAtMs, CATCHUP_MAX_MS));
  if (dt === 0) return creature;
  logger.info('catchup.applying', { dtMs: dt, capped: nowMs - savedAtMs > CATCHUP_MAX_MS });
  const result = runCareTick({ creature, dtMs: dt, nowMs: savedAtMs + dt, lightOn });
  return result.creature;
}
